/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { STAGE_LABEL, FINAL_OUTCOME_LABEL } from '../constants';

// ---------------------------------------------------------------------------
// Painel do relatório do processo de uma vaga (GET /reports/opening/:id →
// { total, by_stage, by_outcome }). Read-only. Mostra o total e as quebras por
// etapa do funil e por desfecho final.
// ---------------------------------------------------------------------------

const Total = styled.div`
   .total-value {
      font-size: 1.8rem;
      font-weight: 800;
      color: ${({ theme }) => theme?.colors?.textPrimary ?? '#1f1f18'};
      line-height: 1;
   }
   .total-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      color: ${({ theme }) => theme?.colors?.textMuted ?? '#6b7280'};
   }
`;

const Group = styled.div`
   margin-top: 16px;

   .group-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      color: ${({ theme }) => theme?.colors?.textMuted ?? '#6b7280'};
      margin-bottom: 8px;
   }
`;

const Chips = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
`;

const Chip = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 5px 12px;
   border-radius: 999px;
   border: 1px solid ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.12)'};
   font-size: 12.5px;
   font-weight: 600;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#1f1f18'};

   strong {
      font-weight: 800;
   }
`;

function toChips(counts, labelMap) {
   if (!counts || typeof counts !== 'object') return [];
   return Object.entries(counts)
      .filter(([, count]) => count > 0)
      .map(([key, count]) => ({
         label: labelMap[key] ?? key,
         count,
      }));
}

export default function OpeningReportPanel({ report }) {
   if (!report) {
      return (
         <p style={{ margin: 0, fontSize: '0.86rem', color: '#6b7280' }}>
            Relatório indisponível.
         </p>
      );
   }

   const stageChips = toChips(report.by_stage, STAGE_LABEL);
   const outcomeChips = toChips(report.by_outcome, FINAL_OUTCOME_LABEL);

   return (
      <div>
         <Total>
            <div className="total-value">{report.total ?? 0}</div>
            <div className="total-label">Candidatos no processo</div>
         </Total>

         {stageChips.length > 0 && (
            <Group>
               <div className="group-label">Por etapa</div>
               <Chips>
                  {stageChips.map((chip) => (
                     <Chip key={chip.label}>
                        {chip.label} <strong>{chip.count}</strong>
                     </Chip>
                  ))}
               </Chips>
            </Group>
         )}

         {outcomeChips.length > 0 && (
            <Group>
               <div className="group-label">Por desfecho</div>
               <Chips>
                  {outcomeChips.map((chip) => (
                     <Chip key={chip.label}>
                        {chip.label} <strong>{chip.count}</strong>
                     </Chip>
                  ))}
               </Chips>
            </Group>
         )}
      </div>
   );
}

OpeningReportPanel.propTypes = {
   report: PropTypes.shape({
      total: PropTypes.number,
      by_stage: PropTypes.object,
      by_outcome: PropTypes.object,
   }),
};
